module.exports = __webpack_public_path__ + "img/google12.8734e324.jpg";